<template>
  <v-row justify="center">
    <v-dialog
      v-model="displaySelf"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Приглашение соискателя в организацию</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                :sm="12"
              >
                <v-text-field
                  v-model="model.cellPhone"
                  label="Номер телефона"
                  required
                  type="number"
                  counter="11"
                  :rules="phoneRules"
                  @change="onCellphoneChanged"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="warning"
            text
            @click="$emit('onCloseInstitutionStaffRequestModal')"
          >
            Отменить
          </v-btn>
          <v-btn
            :disabled="!canSave"
            :color="`success`"
            text
            @click="save"
          >
            {{ `Добавить пользователя` }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>

export default {
  name: 'InstitutionStaffRequestModal',
  props: {
    displaySelf: {
      type: Boolean,
      default: false,
    },
    saveCallback: {
      type: Function,
    },
    organizationId: {
      type: String,
    },
  },
  data: () => ({
    model: {
      cellPhone: '',
    },
    phoneRules: [
      (v) => !!v || ' ',
      (v) => /^79\d{9}$/.test(v) || 'Невалидный формат номера телефона',
    ],
  }),
  computed: {
    canSave () {
      const { cellPhone } = this.model
      return !!cellPhone && cellPhone.trim().length === 11 && /^79\d{9}$/.test(cellPhone)
    },
  },
  watch: {
    model: {
      handler (val) {},
      deep: true,
    },
  },
  created () {
  },
  methods: {
    onCellphoneChanged (data) {
      this.model.user = data
    },
    async save (item) {
      try {
        this.showPageLoader()

        const response = await this.$store.dispatch(
          'organization/createStaffRequest',
          {
            organization: { id: this.organizationId },
            description: item.description,
            username: this.model.cellPhone
          }
        )
        this.hidePageLoader()
        if (this.saveCallback) {
          this.saveCallback()
        }
        this.$emit('onCloseInstitutionStaffRequestModal')

        if (response.data && response.data.description) {
          const message = response.data.message
          switch (response.data.description) {
          case 'user-exists':
            this.showSuccessNotification('Выбранный соискатель зарегистрирован в системе. ' +
                  'Вы можете связаться с соискателем для корректировки его статуса!', 'success')
            break
          case 'request-exists':
            this.showWarningNotification('Выбранный соискатель уже приглашен в другую организацию')
            break
          case 'has-x5-conflict':
            this.showWarningNotification(
              message ||
                'Вы не можете добавить Соискателя в список для своих, так как у него есть активные или будущие смены ' +
                'и/или отклики. Попробуйте снова после отмены или отработки смен'
            )
            break
          case 'has-active-offers':
            this.showWarningNotification(
              message ||
                'Вы не можете добавить Соискателя в список для своих, так как у него есть активные или будущие смены ' +
                'и/или отклики. Попробуйте снова после отмены или отработки смен'
            )
            break
          case 'request-done':
            this.showSuccessNotification('Пользователь успешно добавлен в список!', 'success')
            break
          }
        } else {
          this.showSuccessNotification('Пользователь успешно приглашен!', 'success')
        }
      } catch (error) {
        console.log(error)
        this.hidePageLoader()
        this.showErrorNotification('Не удалось пригласить пользователя', 'error')
      }
    }
  }
}
</script>
